import * as Yup from 'yup';
import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const DISTRIBUTOR_DETAILS_TABS = ['address', 'contact', 'sites', 'logo', 'producer'] as const;
export type DistributorDetailsTab = (typeof DISTRIBUTOR_DETAILS_TABS)[number];

export const DistributorDetailsSearchParamsSchema = Yup.object({
  tab: Yup.mixed<DistributorDetailsTab>()
    .oneOf([...DISTRIBUTOR_DETAILS_TABS])
    .optional()
    .default('address'),
})
  .concat(createPaginationSchema())
  .concat(createSortSchema(['name', 'town', 'county'] as const));
